import { minutesToMilliseconds } from 'date-fns';

export const INACTIVITY_MODAL_DISPLAY_TIME = minutesToMilliseconds(1);

export const SHOW_INACTIVITY_MODAL_AFTER_IDLE_TIME = minutesToMilliseconds(30);
